import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  size?: 'sm' | 'lg' | 'md';
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, size = 'sm' }) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-sm w-full',
    lg: 'max-w-2xl w-full max-h-[80vh]',
    md: 'w-[400px]'
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4"
      onClick={onClose}
    >
      <div 
        className={`bg-white rounded-lg shadow-xl ${sizeClasses[size]} overflow-hidden`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
